import React, { useRef, useEffect } from "react";

export default function WatchPlaylistEpisodeLoadMore({ setLoadMoreEpisodes }) {
  const loadMoreRef = useRef(null);

  useEffect(() => {
    const options = {
      threshold: 0.1,
    };

    let callback = (entries) => {
      if (entries[0].isIntersecting) {
        setLoadMoreEpisodes(true);
      }
    };
    let observer = new IntersectionObserver(callback, options);
    observer.observe(loadMoreRef.current);
  }, []);

  return (
    <p ref={loadMoreRef} style={{ padding: "0 16px" }}>
      Load More
    </p>
  );
}
